import { managementFeeConstants } from "@constants";

const initalState = {
  update: {
    processing: false,
    fail: null
  }
};

export const managementFee = (state = initalState, action) => {
  switch (action.type) {
    case managementFeeConstants.EDIT_MANAGEMENT_FEE_REQUEST:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: true
        }
      };
    case managementFeeConstants.EDIT_MANAGEMENT_FEE_SUCCESS:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: false
        }
      };
    case managementFeeConstants.EDIT_MANAGEMENT_FEE_FAILURE:
      return {
        ...state,
        update: {
          ...initalState.update,
          processing: false,
          fail: action.error
        }
      };
    case managementFeeConstants.RESET_EDIT_MANAGEMENT_FEE_SUCCESS:
      return {
        ...state,
        update: initalState.update
      };
    default:
      return state;
  }
};
